import { describe, it } from 'mocha'
import { expect } from 'chai'

import searchNumbers from './searchNumbers.js'
import metadata from '../../metadata.min.json' with { type: 'json' }

describe('searchNumbers', () => {
	it('should iterate', () => {
		const expectedNumbers =[{
			country : 'RU',
			phone   : '8005553535',
			// number   : '+7 (800) 555-35-35',
			startsAt : 14,
			endsAt   : 32
		}, {
			country : 'US',
			phone   : '2133734253',
			// number   : '(213) 373-4253',
			startsAt : 41,
			endsAt   : 55
		}]

		for (const number of searchNumbers('The number is +7 (800) 555-35-35 and not (213) 373-4253 as written in the document.', 'US', metadata)) {
			expect(number).to.deep.equal(expectedNumbers.shift())
		}

		expect(expectedNumbers.length).to.equal(0)
	})
})